import React from 'react';
import './EmptyState.css';

/**
 * Shared empty/zero-state: headline + one-line explainer + optional primary action.
 *
 * <EmptyState
 *   icon={<Inbox size={24} />}
 *   title="No invoices yet"
 *   subtitle="Create your first invoice to start getting paid in crypto."
 *   action={{ label: 'Create invoice', onClick: handleCreate }}
 * />
 *
 * `action` may also be passed as a ready-made node for custom buttons/links.
 */
const EmptyState = ({ icon, title, subtitle, action, className = '' }) => {
  let actionNode = null;
  if (action) {
    if (React.isValidElement(action)) {
      actionNode = action;
    } else if (action.label) {
      actionNode = (
        <button
          type="button"
          className="ui-empty-state__action"
          onClick={action.onClick}
        >
          {action.icon}
          {action.label}
        </button>
      );
    }
  }

  return (
    <div className={`ui-empty-state ${className}`.trim()}>
      {icon && <div className="ui-empty-state__icon" aria-hidden="true">{icon}</div>}
      {title && <p className="ui-empty-state__title">{title}</p>}
      {subtitle && <p className="ui-empty-state__subtitle">{subtitle}</p>}
      {actionNode}
    </div>
  );
};

export default EmptyState;
